export const USER_STATUS = {
  active: "active",
  deactivated: "deactivated",
} as const;
